export const createReceiptDetails = (cartProducts = []) =>
  cartProducts.map((detail) => ({
    ...detail,
    description: detail.product_name,
    amount: Number(detail.product_price).toFixed(2),
    student_id: detail.student_id,
    student_name: detail.student_name,
  }));
